<template>
    <block-section class="section">
        <div class="container">
            <div class="contact">
                <div class="title">
                    {{ $t("block_footer.customer_center") }}
                </div>
                <div>Fredensgade 45<br />8000 Aarhus C</div>

                <div class="title phone">{{ $t("block_footer.phone") }}</div>
                <div>
                    <a
                        target="_blank"
                        class="textlink"
                        href="https://www.midttrafik.dk/kundeservice/kontakt-os/"
                    >{{ $t("block_footer.se_opening_hours") }}</a>
                </div>
                <div>
                    <a
                        target="_blank"
                        class="textlink"
                        href="https://www.was.digst.dk/webshop-midttrafik-dk"
                    >{{ $t("block_footer.accessibility_statement") }}</a>
                </div>
            </div>

            <div class="payment">
                <div class="title">
                    {{ $t("block_footer.payment_options") }}
                </div>
                <div class="options">
                    <img :src="applePay" alt="Apple Pay">
                    <img :src="dankort" alt="Dankort" />
                    <img :src="mobilepay" alt="MobilePay" />
                    <img :src="mastercard" alt="Mastercard Express" />
                    <img :src="maestro" alt="Maestro" />
                    <img :src="visa" alt="Visa" />
                    <img :src="diners" alt="Diners" />
                    <img :src="jcb" alt="JCB" />
                    <img :src="americanExpress" alt="American Express" />
                </div>
            </div>

            <div class="apps">
                <div class="title">{{ $t("block_footer.get_app") }}</div>
                <div class="options">
                    <div>
                        <a
                            href="https://apps.apple.com/dk/app/midttrafik/id1101101559"
                            :alt="$t('block_footer.get_app_apple')"
                            target="_blank"
                        >
                            <img :src="store_apple" alt="Apple App Store" />
                        </a>
                    </div>
                    <div>
                        <a
                            href="https://play.google.com/store/apps/details?id=dk.midttrafik.mobilbillet"
                            alt="$t('block_footer.get_app_google')"
                            target="_blank"
                        >
                            <img :src="store_google" alt="Google Play Store" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </block-section>
</template>

<script>
const applePay = require("../../assets/images/cards/applepay.svg")
const americanExpress = require("../../assets/images/cards/amercian-express.png");
const jcb = require("../../assets/images/cards/jcb.png");
const maestro = require("../../assets/images/cards/maestro.png");
const mobilepay = require("../../assets/images/cards/mobilepay.png");
const mastercard = require("../../assets/images/cards/mastercard.png");
const diners = require("../../assets/images/cards/diners.png");
const dankort = require("../../assets/images/cards/dankort.png");
const visa = require("../../assets/images/cards/visa.png");

const store_apple = require("../../assets/images/store_apple.png");
const store_google = require("../../assets/images/store_google.png");

export default {
    computed: {
        americanExpress() {
            return americanExpress;
        },
        jcb() {
            return jcb;
        },
        maestro() {
            return maestro;
        },
        mobilepay() {
            return mobilepay;
        },
        mastercard() {
            return mastercard;
        },
        diners() {
            return diners;
        },
        dankort() {
            return dankort;
        },
        visa() {
            return visa;
        },
        applePay() {
            return applePay;
        },
        store_apple() {
            return store_apple;
        },
        store_google() {
            return store_google;
        }
    }
};
</script>

<style scoped lang="scss">
.section {
    background: $color-darkest-grey;
}

.container {
    padding: 2.75rem 0rem;
    color: $color-light-grey;
    display: flex;
    flex-direction: column;

    > * {
        margin-bottom: 2.75rem;
    }

    @media (min-width: $breakpoint-desktop) {
        flex-direction: row;
        justify-content: space-between;

        > * {
            margin-bottom: 0;
        }
    }
}

.contact {
    a {
        color: $color-light-grey;
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}

.title {
    font-weight: 600;
}

.title.phone {
    margin-top: 1.5rem;
}

.payment {
    .options {
        padding-top: 1rem;
        img {
            height: 34px;
            margin-right: 10px;
            margin-bottom: 10px;
        }
    }
}

.apps {
    .options {
        padding-top: 1rem;

        > * {
            margin-bottom: 0.5rem;
        }

        img {
            height: 40px;
            display: block;
        }
    }
}
</style>
